import { ITicketStatus, PLAN_TYPE, Statuses } from "app/types";
import { PriorityFilterEnum, StatusFilterEnum } from "../Ticket/types";
import {
  getPriorityIcon,
  getStatusIcon,
  getTicketIcon,
} from "./containers/Home/containers/helpers";
import {
  Board,
  BoardPermission,
  BoardType,
  RelationType,
  TicketGroup,
  TicketType,
} from "./types";

export const fixedColorCode = [
  "#6554C0",
  "#36B37E",
  "#00B8D9",
  "#FF5630",
  "#6B778C",
  "#4C9AFF",
  "#FFC400",
  "#EE5396",
  "#091E42",
  "#008DA6",
  "#DE350B",
  "#FF991F",
  "#403294",
  "#008274",
  "#1D7AFC",
];
export const fixedTagColorCode = [
  "#EB5757",
  "#F2994A",
  "#F2C94C",
  "#219653",
  "#27AE60",
  "#6FCF97",
  "#47F6CC",
  "#66E9FB",
  "#4DBDED",
  "#4D5DED",
  "#9B51E0",
  "#BB6BD9",
  "#D96BB5",
  "#E9888F",
  "#FE754D",
  "#FEAA4D",
  "#C6C6C6",
  "#828282",
  "#4C5058",
];

export const TICKET_HEADERS = [
  {
    name: "Name",
    id: "name",
    resizable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
  {
    name: "Status",
    id: "status",
    width: "150",
    resizable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
  {
    name: "Assignee",
    id: "assignee",
    resizable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
  {
    name: "Priority",
    id: "priority",
    resizable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
  {
    name: "Due Date",
    id: "dueDate",
    resizable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
];

export const allTickets = [
  {
    id: "TKT-001",
    name: "Implement user login",
    type: TicketType.STORY,
    status: "TO DO",
    assignees: [
      { name: "Alice", color: "#FF5733", online: true },
      { name: "Bob", color: "#33C1FF", online: false }
    ],
    priority: "High",
    dueDate: "2024-04-20",
    sprint: "Sprint 1",
    release: "v1.0.0",
    environment: "Development",
    severity: "Major",
    component: "Authentication",
    creator: "Eve",
    creationDate: "2024-04-01",
    effortsEstimation: 8,
    effortsActual: 5,
    labels: [
      { name: "backend", color: "#3498DB", backgroundColor: "#3498DB2E" },
      { name: "auth", color: "#9B59B6", backgroundColor: "#9B59B62E" }
    ],
    description: "Develop secure user login functionality with token-based authentication."
  },
  {
    id: "TKT-002",
    name: "Fix login redirect bug",
    type: TicketType.BUG,
    status: "IN PROCESS",
    assignees: [
      { name: "Charlie", color: "#FFC107", online: true }
    ],
    priority: "Critical",
    dueDate: "2025-04-10",
    sprint: "Sprint 1",
    release: "v1.0.0",
    environment: "Production",
    severity: "Critical",
    component: "Login",
    creator: "Dave",
    creationDate: "2024-03-30",
    effortsEstimation: 5,
    effortsActual: 4,
    labels: [
      { name: "bug", color: "#FF1A7F", backgroundColor: "#FF1A7F2E" },
      { name: "internal bug", color: "#FF1A7F", backgroundColor: "#FF1A7F2E" }
    ],
    description: "After successful login, the redirect URL is broken. Users are being taken to an incorrect route."
  },
  {
    id: "TKT-003",
    name: "Design forgot password screen",
    type: TicketType.TASK,
    status: "DONE",
    assignees: [
      { name: "Diana", color: "#8E44AD", online: false }
    ],
    priority: "Normal",
    dueDate: "2025-04-12",
    sprint: "Sprint 1",
    release: "v1.0.0",
    environment: "Staging",
    severity: "Minor",
    component: "UI/UX",
    creator: "Frank",
    creationDate: "2024-03-25",
    effortsEstimation: 3,
    effortsActual: 3,
    labels: [
      { name: "UI", color: "#2980B9", backgroundColor: "#2980B92E" },
      { name: "enhancement", color: "#FEC700", backgroundColor: "#FEC7002E" }
    ],
    description: "Create mockup and implement the 'Forgot Password' screen following the design guidelines."
  },
  {
    id: "TKT-004",
    name: "Add multi-language support",
    type: TicketType.TASK,
    status: "TO DO",
    assignees: [
      { name: "Eve", color: "#3498DB", online: true },
      { name: "Bob", color: "#33C1FF", online: false }
    ],
    priority: "Low",
    dueDate: "2025-04-13",
    sprint: "Sprint 2",
    release: "v1.1.0",
    environment: "Development",
    severity: "Trivial",
    component: "Localization",
    creator: "Grace",
    creationDate: "2024-04-05",
    effortsEstimation: 10,
    effortsActual: 15,
    labels: [
      { name: "i18n", color: "#6B7DF8", backgroundColor: "#6B7DF82E" },
      { name: "enhancement", color: "#FEC700", backgroundColor: "#FEC7002E" }
    ],
    description: "Enable app interface to support multiple languages using i18n framework."
  },
  {
    id: "TKT-005",
    name: "Upgrade database engine",
    type: TicketType.TASK,
    status: "TO DO",
    assignees: [
      { name: "Ian", color: "#7F8C8D", online: false }
    ],
    priority: "Medium",
    dueDate: "2025-04-14",
    sprint: "Sprint 2",
    release: "v1.1.0",
    environment: "Production",
    severity: "Major",
    component: "Database",
    creator: "Hank",
    creationDate: "2024-04-03",
    effortsEstimation: 6,
    effortsActual: 2,
    labels: [
      { name: "backend", color: "#34495E", backgroundColor: "#34495E2E" },
      { name: "maintenance", color: "#2ECC71", backgroundColor: "#2ECC712E" }
    ],
    description: "Upgrade PostgreSQL from v11 to v14 to support new features and better performance."
  },
  {
    id: "TKT-006",
    name: "Refactor settings page",
    type: TicketType.STORY,
    status:"IN PROCESS",
    assignees: [
      { name: "Alice", color: "#FF5733", online: true }
    ],
    priority: "High",
    dueDate: "2025-04-22",
    sprint: "Sprint 2",
    release: "v1.1.0",
    environment: "Development",
    severity: "Moderate",
    component: "Settings",
    creator: "Grace",
    creationDate: "2024-04-04",
    effortsEstimation: 5,
    effortsActual: 1,
    labels: [
      { name: "refactor", color: "#E67E22", backgroundColor: "#E67E222E" },
      { name: "UI", color: "#2980B9", backgroundColor: "#2980B92E" }
    ],
    description: "Code cleanup and modularization of the settings page. Ensure it's mobile responsive."
  },
  // ... continue updating the remaining tickets similarly
];


export const PROJECTS = [
  {
    id: "1",
    name: "Digital Innovators Collective",
    icon: {
      avatar: "",
      color: "#FFFFFF",
      backgroundColor: "#5A8DF1",
    },
    owner: {
      id: "1",
      name: "Emerson Philips",
      avatar: "",
      isOnline: true,
    },
    plan: PLAN_TYPE.FREE,
    statuses: [
      Statuses.ABANDONED,
      Statuses.DONE,
      Statuses.IN_CODE_REVIEW,
      Statuses.IN_PROGRESS,
      Statuses.IN_STAGING,
      Statuses.REOPENED,
      Statuses.TODO,
      Statuses.TESTING_IN_PRODUCTION,
    ],
    members: [
      {
        id: "1",
        name: "Emerson Philips",
        status: "active",
        role: "Owner",
      },
      {
        id: "2",
        name: "Phillip Kenter",
        status: "active",
        role: "Developer",
      },
    ],
    createdAt: "2024-02-14 12:00:00",
    storageUsage: 30,
    teams: [
      {
        id: "1",
        name: "TechMate",
        icon: {
          letter: "T",
          backgroundColor: "#B3E8E9",
          color: "#79808A",
        },
        boards: [
          {
            name: "Tickets",
          },
          {
            name: "Sprints",
          },
          {
            name: "Releases",
          },
        ],
      },
      {
        id: "2",
        name: "Tasty Tech",
        icon: {
          letter: "T",
          backgroundColor: "#C5D8F8",
          color: "#79808A",
        },
        boards: [
          {
            name: "Tickets",
          },
          {
            name: "Sprints",
          },
          {
            name: "Releases",
          },
        ],
      },
      {
        id: "3",
        name: "Smart Style",
        icon: {
          letter: "T",
          backgroundColor: "#D8CEFA",
          color: "#79808A",
        },
        boards: [
          {
            name: "Tickets",
          },
          {
            name: "Sprints",
          },
          {
            name: "Releases",
          },
        ],
      },
    ],
  },
];
export const TicketTypeOptions = [
  {
    label: "Task",
    type: TicketType.TASK,
    icon: getTicketIcon(TicketType.TASK),
  },
  {
    label: "Bug",
    type: TicketType.BUG,
    icon: getTicketIcon(TicketType.BUG),
  },
  {
    label: "Story",
    type: TicketType.STORY,
    icon: getTicketIcon(TicketType.STORY),
  },
  {
    label: "Epic",
    type: TicketType.EPIC,
    icon: getTicketIcon(TicketType.EPIC),
  },
];

export const TagList = [
  {
    id: "1",
    name: "internal bug",
    backgroundColor: "#FEC7002E",
    color: "#FF197F",
  },
  {
    id: "2",
    name: "change request",
    backgroundColor: "#FEC7002E",
    color: "#FEC700",
  },
  {
    id: "3",
    name: "figma needed",
    backgroundColor: "#00ABE52E",
    color: "#00ABE5",
  },
  { id: "4", name: "design", backgroundColor: "#00AB7B2E", color: "#00AB7B" },
  {
    id: "5",
    name: "need to fix",
    backgroundColor: "#0022E52E",
    color: "#0022E5",
  },
];
export const StatusTypeOptions = [
  {
    label: StatusFilterEnum.OPENED,
    value: StatusFilterEnum.OPENED,
    icon: getStatusIcon(StatusFilterEnum.OPENED),
    textColor: "text-[#43D98C]",
    color: "#43D98C",
  },
  {
    label: StatusFilterEnum.IN_PROCESS,
    value: StatusFilterEnum.IN_PROCESS,
    icon: getStatusIcon(StatusFilterEnum.IN_PROCESS),
    textColor: "text-[#FEB355]",
    color: "#FEB355",
  },
  {
    label: StatusFilterEnum.DUPLICATE,
    value: StatusFilterEnum.DUPLICATE,
    icon: getStatusIcon(StatusFilterEnum.DUPLICATE),
    textColor: "text-[#FF8FC5]",
    color: "#FF8FC5",
  },
  {
    label: StatusFilterEnum.CLOSED,
    value: StatusFilterEnum.CLOSED,
    icon: getStatusIcon(StatusFilterEnum.CLOSED),
    textColor: "text-[#A394FB]",
    color: "#A394FB",
  },
];
export const priorityOptions = [
  {
    label: PriorityFilterEnum.NORMAL,
    value: PriorityFilterEnum.NORMAL,
    icon: getPriorityIcon(PriorityFilterEnum.NORMAL),
    color: "#2AD95B",
  },
  {
    label: PriorityFilterEnum.HIGH,
    value: PriorityFilterEnum.HIGH,
    icon: getPriorityIcon(PriorityFilterEnum.HIGH),
    color: "#FF8A00",
  },
  {
    label: PriorityFilterEnum.URGENT,
    value: PriorityFilterEnum.URGENT,
    icon: getPriorityIcon(PriorityFilterEnum.URGENT),
    color: "#FF4F4F",
  },
  {
    label: PriorityFilterEnum.LOW,
    value: PriorityFilterEnum.LOW,
    icon: getPriorityIcon(PriorityFilterEnum.LOW),
    color: "#20C6EB",
  },
];
